import { IoReturnUpBack } from "react-icons/io5";
import api from "../api";
const storedData = localStorage.getItem("userData");
const token = storedData ? JSON.parse(storedData).token : null;
const userProfile = async () => {
  return await api.get("/user/get-profile", {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
export const updateUserData = () => {
  if (!token) {
    throw new Error("No token found. Please log in again.");
  }
  return api.put("/user/update-address", {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    }

  });
}

export const deleteAddress = async (addressId) => {
  if (!token) {
    throw new Error("No token found. Please log in again.");
  }
  return await api.delete(`/user/delete-address`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: { addressId },

  });
};

// coupon code api call here
export const proCodeGet = async () => {
  if (!token) {
    throw new Error("No token found. Please log in again.");
  }
  return await api.get("/user/promoCodes", {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    }
  });
}
export const postpromoCode = async (code, product_id) => {

  return await api.post("/user/apply-promo", {
    code: code, // body
    product_id: product_id,
  },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const refrenceProducts = async (_id) => {
  return await api.get(`user/recommended-products/${_id}`, {
    params: { id: _id },
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};


export const checkPinCode = async (pincode, token) => {
  return await api.post(
    "/user/check-pincode",
    { pincode },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const searchProduct = async (query, sectionId) => {
  console.log("sajhfdiuegfiu")
  return await api.get(
    `/user/serachProducts?sectionId=${sectionId}&search=${query}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const socialMedia = async () => {
  return await api.get("/user/contactus", {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    }
  })
}

export const getNotification = async () => {
  const token = storedData ? JSON.parse(storedData).token : null;
  if (!token) throw new Error("Token not found");

  return await api.post(
    "/user/user_notifications",
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};
export const offerProducts = async (offerId) => {
  return await api.get(`/user/offerProducts/${offerId}`,
    { body: offerId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
}

export const fetchSections = async () => {
  return await api.get("/user/getSections"),
  {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  }
}
export const sectionCategory = async (sectionId) => {
  return await api.get(`/user/themed-collections?sectionId=${sectionId}`),
  {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  }
}

export default userProfile;

